import toggle from '../helpers/class-toggle';

export default () => {
	const curBlock = document.querySelector('.js-lang');
	const form = document.getElementById('localization_form');
	const input = document.querySelector('input[name="language_code"], input[name="country_code"]');
	const curButtons = document.querySelectorAll('.js-lang-btn');
	const btnSubmit = document.querySelector('.js-lang-submit');

	if(curBlock && form){

		curButtons.forEach(item => {
			item.addEventListener('click', (e) => {
				e.preventDefault();

				const btn = item.querySelector('.currency__link ');

				let isChanged = toggle(curButtons, item, 'active');

				if (isChanged) {
					input.value = btn.dataset.value;

					if (item.classList.contains('is-default')) {
						curBlock.classList.remove('currency--changed');
					} else {
						curBlock.classList.add('currency--changed');
					}
				}
			});
		});

		if (btnSubmit) {
			btnSubmit.addEventListener('click', (e) => {
				e.preventDefault();
				form.submit();
			});
		}
	}

	/* Currency search box */
	const searchInput = document.getElementById('currencySearch');
	const currencyPopupTrigger = document.querySelectorAll('div.js-open-popup[data-popup="currency"]');

	currencyPopupTrigger.forEach(function(el) {
		el.addEventListener('click', () => {
			// Resetting search
			searchInput.value = "";
			curButtons.forEach(function(item) {
					item.style.display = "";
			});
			searchInput.focus(); // Focusing on input when popup opens
		});
	});

	searchInput.addEventListener('keyup', function() {
		// Get the current value of the search input
		let filterValue = this.value.toLowerCase();

		// Loop through each item and hide/show based on match
		curButtons.forEach(function(item) {
			// Extract the currency name from the span
			let currencyName = item.querySelector('span').textContent || item.querySelector('span').innerText;

			// Check if the filterValue matches either the currencyName or dataValue
			if (currencyName.toLowerCase().indexOf(filterValue) == 0) {
				item.style.display = "";
			} else {
				item.style.display = "none";
			}
		});
	});
}